const ResidentialArea = Object.freeze({
  QUIET: 'QUIET',
  URBAN: 'URBAN',
  RURAL: 'RURAL',
})

export default ResidentialArea
